import React from 'react'
import Moment from 'react-moment'
import marked from 'marked'
import PropTypes from 'prop-types'

import pin from '../images/icons/pin.png'

Moment.globalFormat = 'DD/MM/YY'

export default class BlogPost extends React.Component {
  static propTypes = {
    town: PropTypes.string.isRequired,
    region: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    main: PropTypes.string.isRequired,
    tags: PropTypes.array.isRequired,
  }

  render () {
    const { title, date, src, alt, main, tags, town, region } = this.props
    return (
      <section className="blog relative">
        <div className="blog__content-wrapper">
          <article className="blog__content">
            <div className="blog__content-header">
              <h4><Moment element="span" parse="YYYY-MM-DD">{ date }</Moment></h4>
              <h3>{ title }</h3>
              { town !== null && region !== null
                && <p className="blog__content-location">{ `${town}, ${region}` } <img src={pin} alt="location" /></p>
              }
            </div>
            <img className="blog__content-image" src={src} alt={alt} />
            <div
              className="blog__content-body"
              dangerouslySetInnerHTML={{ __html: marked(main) }}
            />
            <div className="blog__content-tags">
              <p>Tags:</p>
              { tags.map((tag, i) => (
                <span key={i}>{tag}</span>
              )) }
            </div>
          </article>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/BlogPost.js